var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2243_36196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2427 7.75734C9.58915 7.10386 8.81131 6.62009 7.96263 6.32723C8.87159 5.7012 9.46875 4.65347 9.46875 3.46875C9.46875 1.55609 7.91266 0 6 0C4.08734 0 2.53125 1.55609 2.53125 3.46875C2.53125 4.65347 3.12841 5.7012 4.03739 6.32723C3.18872 6.62009 2.41088 7.10386 1.75737 7.75734C0.624117 8.89062 0 10.3973 0 12H0.9375C0.9375 9.20852 3.20852 6.9375 6 6.9375C8.79148 6.9375 11.0625 9.20852 11.0625 12H12C12 10.3973 11.3759 8.89062 10.2427 7.75734ZM6 6C4.60427 6 3.46875 4.8645 3.46875 3.46875C3.46875 2.073 4.60427 0.9375 6 0.9375C7.39573 0.9375 8.53125 2.073 8.53125 3.46875C8.53125 4.8645 7.39573 6 6 6Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2243_36196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfo);
export default __webpack_public_path__ + "static/media/user-info.9eb394b3d56a89d5094bd1ceb69abf77.svg";
export { ForwardRef as ReactComponent };